"use client"

import type { PromotionBottomBannerProps } from "@/types/types"
import { ComponentConfig } from "@measured/puck"
import { ImageUploadField } from "../../../lib/ImageUploadField"
import { commonStylesProps } from "../../../lib/commonCSSProps"
import { RenderConfig } from "./RenderConfig"

export const PromotionBottomBanner: ComponentConfig<PromotionBottomBannerProps> = {
  label: "Tamda One | Promotion Bottom Banner",
  fields: {
    mobileHeight: {
      label: "Mobile Height",
      type: "text",
    },
    desktopHeight: {
      label: "Desktop Height",
      type: "text",
    },
    banners: {
      label: "Banners",
      type: "array",
      getItemSummary: (item: any, index = 0) => `Banner ${index + 1}: ${item?.title || ""}`,
      arrayFields: {
        image: {
          label: "Image Background",
          type: "custom",
          render: (props: any) => <ImageUploadField {...props} />,
        },
        title: {
          label: "Title",
          type: "text",
        },
        buttonText: {
          label: "Button Text",
          type: "text",
        },
        buttonLink: {
          label: "Button Link",
          type: "text",
        },
      },
      defaultItemProps: {
        image: "",
        title: "",
        buttonText: "",
        buttonLink: "",
      },
    },
    ...(commonStylesProps as any),
  },
  defaultProps: {
    mobileHeight: "300px",
    desktopHeight: "690px",
    banners: [],
    className: "",
    styles: {
      mobile: {
        display: "block",
      },
      tablet: {
        display: "block",
      },
      desktop: {
        display: "block",
      },
    },
    responsiveType: "mobileFirst",
    animation: {
      "data-aos": "",
      "data-aos-duration": "",
    },
  },
  ...RenderConfig,
}

export type { PromotionBottomBannerItem, PromotionBottomBannerProps } from "@/types/types"
